import { DesignToken } from "@livechat/design-system-react-components";

import { ReportType } from "constants/reports/report-type";
import { withVar } from "themes/helpers";

import {
  getChartOptions as getCommonChartOptions,
  getNavigationResolver,
  getWeekDayLabelsFromPeriod,
} from "../../helpers";

const chartCommonProps = {
  chart: {
    type: "column",
    height: 200,
  },
  xAxis: {
    lineColor: withVar(DesignToken.BorderBasicSecondary),
    tickLength: 0,
  },
  tooltip: false,
  plotOptions: {
    series: {
      states: {
        hover: {
          enabled: false,
        },
      },
    },
  },
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export function getChartOptions(series: any, xLabels: any) {
  const labelOptions = {
    xAxis: {
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      categories: xLabels.map((value: any) => ({
        label: getWeekDayLabelsFromPeriod(value),
        value,
      })),
    },
  };
  return getCommonChartOptions(
    series,
    xLabels,
    // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
    null,
    getNavigationResolver("/reports/new-tickets"),
    chartCommonProps,
    labelOptions
  );
}

export function resolveReportsUrl(report: ReportType): string {
  return `/reports/${report}`;
}
